<div mdbModal #AddDocReferencia="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                   Agregar Doc. Referencia
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>

                <form autocomplete="off" [formGroup]="formHeader">
                    <div class="modal-body">
                      <div class="container">

                        <div class="row">
                          <div class="col">
                            <input type="hidden" name="indice" [value]="correlativo">
                            <!-- <div class="form-group row md-form input-group">
                              <span for="lineax" class="col-sm-3 col-form-label col-form-label-sm">Linea</span>
                              <input value="" type="number" id="lineax" class="col-5 form-control"
                                #lineax />
                            </div> -->
                            <div class="row">
                              <div class="col">
                                <span for="tipox" class="col-sm-3 col-form-label col-form-label-sm">Tipo</span>

                                <mdb-select style="width: 41%; margin-left: 12%;" [options]="optionsDoctoReferencia" [multiple]="false" [filterEnabled]="true" [highlightFirst]="false"
                                placeholder="Seleccionar ..." id="tipox" required formControlName="TipoDoc"></mdb-select>
                                <div class="formDocRazonRef"
                                *ngIf="formHeader.get('TipoDoc').invalid && (formHeader.get('TipoDoc').dirty || formHeader.get('TipoDoc').touched)">
                                <mdb-error *ngIf="formHeader.get('TipoDoc').hasError('required')"> Ingrese
                                  tipo de documento
                                </mdb-error>
                              </div>
                              </div>


                              <!-- <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="801" checked/>
                                <label class="form-check-label" for="inlineRadio1">Orden de Compra</label>
                              </div>

                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="" />
                                <label class="form-check-label" for="inlineRadio2">OC</label>
                              </div> -->

                            </div>
                            <div class="col">
                              <div class="form-group row md-form input-group">
                                <span for="nrodox" class="col-sm-3 col-form-label col-form-label-sm">Nro Doc.</span>
                                <input placeholder="Ingresar nro doc." required formControlName="NroDoc" class="form-control col-5" type="text" id="nrodox"
                                  maxLength="200" #nrodox />
                              </div>
                              <div class ="formDocRef"
                              *ngIf="formHeader.get('NroDoc').invalid && (formHeader.get('NroDoc').dirty || formHeader.get('NroDoc').touched)">
                              <mdb-error *ngIf="formHeader.get('NroDoc').hasError('required')"> Ingrese
                                número del documento
                              </mdb-error>
                            </div>
                            </div>

                            <div class="col">
                              <div class="form-group row md-form input-group">
                                <span for="fechadocx" class="col-sm-3 col-form-label col-form-label-sm">Fecha</span>
                                <mdb-date-picker [inline]="true" name="fechaInicio" id="fechadocx"
                                [placeholder]="'Fecha Doc.'" required formControlName="FechaDoc"> </mdb-date-picker>
                                <div class="formDocFecha"
                                *ngIf="formHeader.get('FechaDoc').invalid && (formHeader.get('FechaDoc').dirty || formHeader.get('FechaDoc').touched)">
                                <mdb-error *ngIf="formHeader.get('FechaDoc').hasError('required')"> Ingrese
                                  fecha
                                </mdb-error>
                              </div>
                              </div>
                            </div>

                            <div class="col">
                              <div class="form-group row md-form input-group">
                                <span for="razonRefx" class="col-sm-3 col-form-label col-form-label-sm">Razón Ref.</span>
                                <input placeholder="Ingresar razón referencia" required class="form-control col-5" type="text" id="razonRefx"
                                  #razonRefx formControlName="Razonref"/>
                                  <div class="formDocRazonRef"
                                  *ngIf="formHeader.get('Razonref').invalid && (formHeader.get('Razonref').dirty || formHeader.get('Razonref').touched)">
                                  <mdb-error *ngIf="formHeader.get('Razonref').hasError('required')"> Ingrese
                                    razón de referencia
                                  </mdb-error>
                                </div>
                              </div>
                            </div>


                          </div>

                        </div>
                      </div>
                      <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                            (click)="hide()" mdbWavesEffect>Cerrar</button>

                            <button mdbBtn type="button" class="btn btn-sm" mdbWavesEffect color="secondary"
                            (click)="GuardarFormulario();">
                            <mdb-icon fas icon="bookmark"></mdb-icon>
                            Guardar
                          </button>
                    </div>
                    </div>
                  </form>





    </div>
</div>
